// Непрозрачная рамка картинки (доли ширины и высоты): по альфе, один раз на URL. Нужна стадиям зон, которые
// растягиваются в прямоугольник фона (bg_rect): в прямоугольник ложится рисунок, а не прозрачные поля вокруг.
export type Box = [number, number, number, number];
const cache = new Map<string, Promise<Box>>();

export function opaqueBox(url: string): Promise<Box> {
  let p = cache.get(url);
  if (p) return p;
  p = new Promise<Box>((resolve) => {
    const img = new Image();
    img.decoding = 'async';
    img.onerror = () => resolve([0, 0, 1, 1]);
    img.onload = () => {
      try {
        const w = Math.min(img.naturalWidth, 256);
        const h = Math.round((img.naturalHeight / img.naturalWidth) * w);
        const c = document.createElement('canvas');
        c.width = w; c.height = h;
        const g = c.getContext('2d', { willReadFrequently: true })!;
        g.drawImage(img, 0, 0, w, h);
        const d = g.getImageData(0, 0, w, h).data;
        let x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
          if (d[(y * w + x) * 4 + 3]! > 16) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        }
        resolve(x1 < 0 ? [0, 0, 1, 1] : [x0 / w, y0 / h, (x1 + 1) / w, (y1 + 1) / h]);
      } catch { resolve([0, 0, 1, 1]); }
    };
    img.src = url;
  });
  cache.set(url, p);
  return p;
}
